const sectionIconWithTextSliderCss = `
[data-type='section-icon-with-text-slider'] [data-attribute='card-container'] .swiper-pagination .swiper-pagination-bullet {
  opacity: 1;
  background-color: var(--pagination-inactive-color, #cccccc);
}

[data-type='section-icon-with-text-slider']
  [data-attribute='card-container']
  .swiper-pagination
  .swiper-pagination-bullet-active {
  background-color: var(--pagination-active-color, #000) !important;
}

/* [data-attribute='card-container'] {
   padding: 40px 0;
   position: relative;
   @container (max-width: 768px) {
     padding: 16px 0;
   }
 }
*/

[data-type='section-icon-with-text-slider'] .wrap-card .swiperIconWithTextSlider {
  padding: 24px 0;
  position: relative;
}

[data-type='section-icon-with-text-slider'] .wrap-card .swiperIconWithTextSlider .swiper-pagination-bullet-active {
  background-color: #000000;
}

[data-type='section-icon-with-text-slider'] .wrap-card .swiper-slide .wrap-ct {
  display: flex;
  align-items: center;
}

[data-type='section-icon-with-text-slider'] .wrap-card .swiper-slide .wrap-ct .wrap-img {
  width: 50px;
}

[data-type='section-icon-with-text-slider'] .wrap-card .swiper-slide .wrap-ct .wrap-img img {
  display: block;
  width: 100%;
  height: auto;
}

[data-type='section-icon-with-text-slider'] .wrap-card .swiper-slide .wrap-ct .wrap-text {
  flex-grow: 1;
  width: calc(100% - 50px);
  padding-left: 10px;
  color: #fff;
  font-weight: bold !important;
  line-height: 1.2;
  line-clamp: 2;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
}

[data-type='section-icon-with-text-slider'] .wrap-card .swiper-slide .wrap-ct .wrap-text * {
  margin-bottom: 0;
  font-size: 16px;
}

@container (max-width: 768px) {
  [data-type='section-icon-with-text-slider'] .wrap-card .swiperIconWithTextSlider {
    padding: 16px 0;
  }

  [data-type='section-icon-with-text-slider'] .wrap-card .swiper-slide .wrap-ct .wrap-text * {
    font-size: 14px;
  }
}
`;

export default sectionIconWithTextSliderCss;
